import PropTypes from 'prop-types';
import React from 'react';
import Lottie from 'lottie-react';
import { Modal } from '@mui/material';
import LoaderJson from '../../../Assets/Images/Loader.json';

export default function Loading({ open, onClose }) {
	return (
		open && (
			<Modal
				slotProps={{ backdrop: { style: { opacity: 0 } } }}
				open={open}
				onClose={onClose}
			>
				<div
					style={{
						border: 'none',
						outline: 'none',
						width: '100vw',
						height: '100vh',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center'
					}}
				>
					<Lottie
						animationData={LoaderJson}
						loop={true}
						style={{ height: '300px', width: '300px' }}
					/>
				</div>
			</Modal>
		)
	);
}

Loading.propTypes = {
	open: PropTypes.any,
	onClose: PropTypes.any
};
